/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Fade } from 'react-awesome-reveal';

export default function DigitalProductList() {
  const products = [
    {
      id: 1,
      title: 'Setting Power & Speed Laser CO2',
      description: 'Panduan lengkap untuk mengoptimalkan setting power dan speed pada mesin laser CO2. Dapatkan hasil cutting dan engraving yang sempurna dengan parameter yang tepat untuk berbagai material.',
      features: [
        'Setting untuk berbagai jenis material',
        'Optimasi kecepatan cutting',
        'Tips troubleshooting',
        'Tabel referensi power & speed',
      ],
      status: 'coming_soon',
      price: 'Segera Hadir',
      image: '/images/digital-product-1.jpg',
    },
    {
      id: 2,
      title: 'CO2 Laser Alignment',
      description: 'Teknik profesional untuk melakukan alignment laser CO2 dengan presisi tinggi. Pelajari cara mengatur cermin dan lensa untuk mencapai fokus laser yang optimal.',
      features: [
        'Langkah-langkah alignment detail',
        'Teknik pengecekan akurasi',
        'Video tutorial lengkap',
        'Tools & equipment yang dibutuhkan',
      ],
      status: 'coming_soon',
      price: 'Segera Hadir',
      image: '/images/digital-product-2.jpg',
    },
    {
      id: 3,
      title: 'Mengganti Tabung Laser CO2 Sendiri',
      description: 'Panduan step-by-step untuk mengganti tabung laser CO2 dengan aman dan benar. Hemat biaya service dengan melakukan penggantian tabung sendiri tanpa mengurangi kualitas dan keamanan mesin.',
      features: [
        'Prosedur penggantian tabung yang aman',
        'Tips memilih tabung laser berkualitas',
        'Cara instalasi dan testing',
        'Troubleshooting masalah umum',
      ],
      status: 'coming_soon',
      price: 'Segera Hadir',
      image: '/images/digital-product-3.jpg',
    },
  ];

  return (
    <section className="container mx-auto px-4 py-20">
      <Fade direction="up" triggerOnce>
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-theme-blue mb-4">
            Produk Digital
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tingkatkan skill dan pengetahuan Anda dengan produk digital berkualitas tinggi.
            Panduan praktis untuk memaksimalkan performa mesin CNC & Laser CO2 Anda.
          </p>
        </div>
      </Fade>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {products.map((product, index) => (
          <Fade
            key={product.id}
            direction="up"
            delay={index * 100}
            triggerOnce
          >
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-2 border-gray-100">
              {/* Product Image Placeholder */}
              <div className="relative h-64 bg-gradient-to-br from-theme-purple to-theme-blue flex items-center justify-center">
                <div className="text-white text-center p-6">
                  <svg
                    className="w-24 h-24 mx-auto mb-4 opacity-80"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    />
                  </svg>
                  <h3 className="text-2xl font-bold">{product.title}</h3>
                </div>
                
                {/* Status Badge */}
                {product.status === 'coming_soon' && (
                  <div className="absolute top-4 right-4 bg-yellow-400 text-gray-900 px-4 py-2 rounded-full font-bold text-sm shadow-lg">
                    Segera Hadir
                  </div>
                )}
              </div>

              {/* Product Details */}
              <div className="p-6">
                <p className="text-gray-700 mb-6 leading-relaxed">
                  {product.description}
                </p>

                <div className="mb-6">
                  <h4 className="font-bold text-theme-blue mb-3 text-lg">
                    Apa yang Anda dapatkan:
                  </h4>
                  <ul className="space-y-2">
                    {product.features.map((feature) => (
                      <li
                        key={`${product.id}-${feature}`}
                        className="flex items-start text-gray-600"
                      >
                        <svg
                          className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="flex items-center justify-between pt-6 border-t border-gray-200">
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Harga</p>
                    <p className="text-2xl font-bold text-theme-purple">
                      {product.price}
                    </p>
                  </div>
                  
                  {product.status === 'available' ? (
                    <button
                      type="button"
                      className="bg-theme-purple text-white px-8 py-3 rounded-full font-bold hover:bg-dark-theme-purple transition duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
                    >
                      Beli Sekarang
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="bg-gray-300 text-gray-600 px-8 py-3 rounded-full font-bold cursor-not-allowed"
                      disabled
                    >
                      Coming Soon
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Fade>
        ))}
      </div>

      {/* CTA Section */}
      <Fade direction="up" delay={200} triggerOnce>
        <div className="mt-20 text-center bg-gradient-to-r from-theme-purple to-theme-blue rounded-2xl p-12 text-white shadow-2xl">
          <h2 className="text-3xl font-bold mb-4">
            Butuh Konsultasi Lebih Lanjut?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Tim kami siap membantu Anda memilih produk digital yang sesuai dengan kebutuhan
          </p>
          <a
            href="https://wa.me/6281903796810"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-theme-purple px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Hubungi Kami via WhatsApp
          </a>
        </div>
      </Fade>
    </section>
  );
}
